import { Center, Image, StyleProps } from '@chakra-ui/react';
import { FC } from 'react';

import { rem } from '../../../design-system/utils';
import { useLocalStorage } from '../../../lib/storage';
import { Drink, getCupFillerImage } from './cup-filler-image';

type CupFillerProps = StyleProps & {
	percentage: number;
};

const DRINKS = [Drink.Juice, Drink.Tea, Drink.Coffee, Drink.BubbleTea, Drink.Cocoa];

export const CupFiller: FC<CupFillerProps> = ({ percentage, ...rest }) => {
	const [drink, setDrink] = useLocalStorage('gratitude-gauge-open:cup', DRINKS[Math.floor(Math.random() * DRINKS.length)]);

	const handleClick = () => {
		if (drink) {
			setDrink(DRINKS[(DRINKS.indexOf(drink) + 1) % DRINKS.length]);
		}
	};

	return (
		<Center boxSize={rem(54)} borderRadius="md" bgColor="purple.300" {...rest}>
			<Image
				src={getCupFillerImage(percentage, drink)}
				onClick={handleClick}
				boxSize={10}
				data-testid="drink-image"
				cursor="pointer"
				_active={{ animation: 'dissolve 4s linear forwards' }}
			/>
		</Center>
	);
};
